import Cookies from 'js-cookie';
import utils from './utils';
import User from './user';
import Request from './request';
import i18n from './i18n';

class Store {
  constructor() {
    let userInfo;
    try {
      userInfo = JSON.parse(window.localStorage.getItem('login'));
    } catch (error) {
      console.debug('user not login');
    }
    if (userInfo && userInfo.id) {
      this.user = new User(userInfo);
    }

    this.langs = [
      {id: 'zh', name: '简体中文'},
      {id: 'en', name: 'English'},
      {id: 'ja', name: '日本語'},
      {id: 'ko', name: '한국어'},
      // {id: 'zh-hant', name: '繁體中文'},
    ]

    const lang = window.localStorage.getItem('lang') || 'zh'
    this.lang = this.langs.find(l => l.id === lang) || this.langs[0]

    i18n.changeLanguage(this.lang.id);
  }

  async dispatch(action) {
    if (!action || !action.type) {
      console.warn(`ACTION not exists please check ${action}`);
    }
    switch (action.type) {
      case 'updateUser':
        this.updateUser();
        break;
      case 'updateNotification':
        await this.updateNotification();
        break;
      case 'updateLang':
        this.lang = this.langs.find(l => l.id === action.payload) || this.langs[0]
        window.localStorage.setItem('lang', action.payload);
        i18n.changeLanguage(action.payload);
        // window.location.reload();
        break;
      default:
        break;
    }
  }

  async updateNotification() {
    const notifications = await Request.call('getPushMessages');
    if (notifications) {
      this.notifications = notifications;
    }
  }

  async updateUser() {
    const userInfo = await Request.call('getUserStatus');
    if (userInfo && userInfo.id) {
      this.user = new User(userInfo);
      document.querySelector('.mt-1').textContent = this.user.userDesc;
      window.localStorage.setItem('login', JSON.stringify(userInfo));
      Cookies.set('malus-token', userInfo.token, {
        domain: `.${window.location.host
          .split('.')
          .slice(-2)
          .join('.')}`,
      });
    }
    utils.injectMarketTool(userInfo);
  }

  logout() {
    window.localStorage.setItem('login', null);
    Cookies.remove('malus-token', {
      domain: `.${window.location.host
        .split('.')
        .slice(-2)
        .join('.')}`,
    });
  }
}

const store = new Store();

export default store;
